import React from "react";
import { apiCall_domain } from "../api";
import axios from "axios";
import Drawer from "@mui/material/Drawer";
import clsx from "clsx";
import List from "@mui/material/List";
import { makeStyles } from "@mui/styles";
import RadioGroup from "@mui/material/RadioGroup";
const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});
const classes = useStyles;
let DetailsAdd = null;
class UserAddressDrawer extends React.Component {
  state = {
    loading: true,
    show: false,
    editHnadle: false,
  };
  render() {
    const addressClickHandler = async (item) => {
      const add = await [];
      const first = await {
        Address: item.address,
        Phone: item.address_phone,
        Title: item.title,
        lat: item.lat,
        lng: item.lng,
      };
      add.push(first);
      DetailsAdd = add;
      localStorage.setItem("lat", item.lat);
      localStorage.setItem("lng", item.lng);
      {
        this.state.editHnadle !== true && window.location.reload();
      }
    };
    const handleAddAddress = () => {
      this.props.props.history.push({
        pathname: "/address/addAddress",
        state: this.props.county,
        show: this.props.props.location.show,
        backToMultiVendor: true,
      });
    };
    const editDetails = async (e) => {
      const wait = await this.state.show;
      this.setState({ show: true, editHnadle: true });
      this.props.props.history.push({
        pathname: "/address/addAddress",
        state: this.props.county,
        details: e,
        validation: true,
        backToMultiVendor: true,
      });
    };

    const deleteItem = (e) => {
      const headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      const deleteData = { id: e };
      axios
        .post(`${apiCall_domain}/customer/user/addresses/delete`, deleteData, {
          headers: headers,
        })
        .then((res) => {
          window.location.reload();
        })
        
    };
    const toggleDrawer = (anchor, open) => (event) => {
      if (
        event.type === "keydown" &&
        (event.key === "Tab" || event.key === "Shift")
      ) {
        return;
      }
      this.setState({ ...this.state, [anchor]: open });
    };

    const list = (anchor) => (
      <div
        className={clsx(classes.list, {
          [classes.fullList]: anchor === "top" || anchor === "bottom",
        })}
        role="presentation"
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <List>
          <div className="drawerMap">
            <div className="ChoseAddress">
              {this.props.myAddresses !== undefined &&
              this.props.myAddresses.length != 0 &&
              this.state.DetailsAdd !== null ? (
                <RadioGroup
                  aria-label="آدرس های من"
                  name="gender1"
                >
                  <div className="addNewAddresses">
                    <div className="addressComTitlemultiVendor">
                      انتخاب آدرس
                    </div>
                    <div
                      className="addressAddMain"
                      onClick={() => handleAddAddress()}
                    >
                      <button>افزودن آدرس</button>
                    </div>
                  </div>
                  {this.props.myAddresses !== undefined &&
                    this.props.myAddresses.map((item) => (
                      <div
                        className="innerBoxMultiVendor"
                        onClick={() => addressClickHandler(item)}
                      >
                        <div className="addressMultiVendor">{item.title}</div>
                        <div className="adressBoxMultiVendor">
                          {item.address}
                        </div>
                        <div className="dividerMultiVendor"></div>
                        <div className="addressBoxInnerBottomMultiVendor">
                          <div className="first">
                            <span className="firstSpan">شماره تماس :</span>
                            <span>{item.address_phone}</span>
                          </div>
                          <div className="seccond">
                            {/* <div
                                    className="secDiv"
                                    onClick={() => pushPaige(item)}
                                  >
                                    <img
                                      src="/public/assets/icons/location.svg"
                                      alt="مکان"
                                    />
                                  </div> */}
                            <div
                              className="secDiv"
                              onClick={() => editDetails(item)}
                            >
                              <img
                                src="/public/assets/icons/medad.svg"
                                alt="مکان"
                              />
                            </div>
                            <div
                              className="secDiv"
                              onClick={() => deleteItem(item.id)}
                            >
                              <img
                                src="/public/assets/icons/zarbdar.svg"
                                alt="مکان"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </RadioGroup>
              ) : (
                <div className="addNewAddresses">
                  <div className="addressComTitlemultiVendor">انتخاب آدرس</div>
                  <div
                    className="addressAddMain"
                    onClick={() => handleAddAddress()}
                  >
                    <button>افزودن آدرس</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </List>
      </div>
    );
    return (
      <>
        {["bottom"].map((anchor) => (
          <React.Fragment key={anchor}>
            <>
              <div className="position" onClick={toggleDrawer(anchor, true)}>
                <img src="/public/assets/icons/locat5ionVendor.svg" alt="pic"/>
                <span>موقعیت من</span>
                <img
                  className="downArrowVendor"
                  src="/public/assets/icons/downArrowVendor.svg"
                  alt="pic"/>
              </div>
              <Drawer
                anchor={anchor}
                open={this.state[anchor]}
                onClose={toggleDrawer(anchor, false)}
              >
                {list(anchor)}
              </Drawer>
            </>
          </React.Fragment>
        ))}
      </>
    );
  }
}
export default UserAddressDrawer;
